import { useEffect } from 'react';
import axios from 'axios';
import { UserControllerApi } from '../api/generated';
import { createApiConfiguration } from '../api/apiConfig';
import { useAppDispatch } from '../store/hooks';
import { setPermissions, clearPermissions } from '../store/permissions/permissionsSlice';

export function useFetchPermissions(locationId: string | undefined) {
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (!locationId) {
      dispatch(clearPermissions());
      return;
    }

    const controller = new AbortController();
    const api = new UserControllerApi(createApiConfiguration());

    api
      .getCurrentUserPermissions({ locationId }, { signal: controller.signal })
      .then((response) => {
        dispatch(
          setPermissions({
            read: response.data.read,
            write: response.data.write,
            patientBooker: response.data.patientBooker
          })
        );
      })
      .catch((err: unknown) => {
        if (axios.isCancel(err)) return;
        dispatch(clearPermissions());
      });

    return () => {
      controller.abort();
    };
  }, [locationId, dispatch]);
}
